import React, { Component } from 'react';
import http from '../../modules/api';
import AICopywriterModal, { getCopywriterBackdropColor } from './AICopywriterModal';
import TitleContentDialogV2 from '../../modules/dialogs/TitleContentDialogV2';
import InputDialogV3 from '../../modules/dialogs/InputDialogV3';

const COPYWRITER_RUN_TUTORIAL_EVENT = 'instagram-tutorial:copywriter-run-action';

const BASIC_AI_PRESET = {
  id: '',
  title: '베이직 AI',
  description: 'AI 카피라이터 설정 없이 기본 방식으로 인스타그램 문장을 생성합니다.',
  defaultYn: 'N',
  isBasic: true,
};

class RoboMDAICopywriterModal extends Component {
  constructor(props) {
    super(props);

    this.modalRef = React.createRef();
    this.dragContext = null;
    this.toastTimer = null;
    this.copywriterSelectionSaveTimer = null;
    this.tutorialRunBackup = null;

    this.state = {
      isSelectModalOpen: false,
      dragX: 0,
      dragY: 0,
      toastMessage: '',
      historyMenuSeq: null,
      isMobileHistoryOpen: false,
      isHistoryDeleteDialogOpen: false,
      historyDeleteTarget: null,
      isHistoryRenameDialogOpen: false,
      historyRenameTarget: null,
      historyDuplicateSeq: null,

      selectedPresetId: '',
      selectedPreset: null,
      presetList: [],
      isPresetLoading: false,
      presetInitialized: false,

      command: props.initialCommand || '',
      recommendations: [],
      selectedIndexes: [],
      isGenerating: false,

      generationCount: 3,
      isAutoHashtagOn: false,
      hashtagGenerationCount: 5,

      historyItems: [],
      historySourceType: 'MANUAL',
      copywriterHistorySeq: null,
      selectedHistorySeq: null,
      selectedHistoryInfo: null,
      isAutoHistory: false,
      isHistoryLoading: false,
      isHistoryDetailLoading: false,

      gptUsageLoading: false,
      gptUsage: {
        total_available_gpt_char_count: 0,
        total_used_gpt_char_count: 0,
        is_api_limit_apply_yn: 'N',
      },
    };
  }

  componentDidMount() {
    window.addEventListener(COPYWRITER_RUN_TUTORIAL_EVENT, this.handleTutorialRunAction);
    if (this.props.isOpen) {
      this.initializeForOpen();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.tutorialRunBackup = null;
      this.clearToastTimer();
      this.setState({
        isSelectModalOpen: false,
        dragX: 0,
        dragY: 0,
        toastMessage: '',
        historyMenuSeq: null,
        isMobileHistoryOpen: false,
        isHistoryDeleteDialogOpen: false,
        historyDeleteTarget: null,
        isHistoryRenameDialogOpen: false,
        historyRenameTarget: null,
        historyDuplicateSeq: null,
      }, this.initializeForOpen);
      return;
    }

    if (prevProps.isOpen && !this.props.isOpen) {
      this.tutorialRunBackup = null;
      this.stopModalDrag();
      this.clearToastTimer();
      this.flushSelectionSave();
      if (
        this.state.isSelectModalOpen ||
        this.state.toastMessage ||
        this.state.historyMenuSeq ||
        this.state.isMobileHistoryOpen ||
        this.state.isHistoryDeleteDialogOpen ||
        this.state.isHistoryRenameDialogOpen ||
        this.state.historyDuplicateSeq
      ) {
        this.setState({
          isSelectModalOpen: false,
          toastMessage: '',
          historyMenuSeq: null,
          isMobileHistoryOpen: false,
          isHistoryDeleteDialogOpen: false,
          historyDeleteTarget: null,
          isHistoryRenameDialogOpen: false,
          historyRenameTarget: null,
          historyDuplicateSeq: null,
        });
      }
      return;
    }

    const fixedModeChanged =
      prevProps.presetMode !== this.props.presetMode ||
      String(prevProps.fixedPresetSeq || '') !== String(this.props.fixedPresetSeq || '');

    if (this.props.isOpen && fixedModeChanged) {
      this.startNewHistory();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(COPYWRITER_RUN_TUTORIAL_EVENT, this.handleTutorialRunAction);
    this.tutorialRunBackup = null;
    this.stopModalDrag();
    this.clearToastTimer();
    this.flushSelectionSave();
  }

  handleTutorialRunAction = (event) => {
    if (!this.props.isOpen) return;

    const detail = event && event.detail ? event.detail : {};
    const action = String(detail.action || '').toUpperCase();

    if (action === 'RESTORE') {
      this.restoreTutorialRunState();
      return;
    }

    if (action === 'SHOW_HISTORY') {
      this.snapshotTutorialRunState();
      if (this.isHistoryEnabled() && !this.state.isMobileHistoryOpen) {
        this.setState({ isMobileHistoryOpen: true, historyMenuSeq: null });
      }
      return;
    }

    if (action === 'HIDE_HISTORY') {
      this.snapshotTutorialRunState();
      if (this.state.isMobileHistoryOpen) {
        this.setState({ isMobileHistoryOpen: false, historyMenuSeq: null });
      }
    }
  };

  snapshotTutorialRunState = () => {
    if (this.tutorialRunBackup) return;
    this.tutorialRunBackup = {
      isMobileHistoryOpen: this.state.isMobileHistoryOpen,
      isSelectModalOpen: this.state.isSelectModalOpen,
      historyMenuSeq: this.state.historyMenuSeq,
    };
  };

  restoreTutorialRunState = () => {
    if (!this.tutorialRunBackup) {
      if (this.state.isMobileHistoryOpen || this.state.isSelectModalOpen) {
        this.setState({
          isMobileHistoryOpen: false,
          isSelectModalOpen: false,
          historyMenuSeq: null,
        });
      }
      return;
    }

    const backup = this.tutorialRunBackup;
    this.tutorialRunBackup = null;
    this.setState(backup);
  };

  setStateAsync = (nextState) => new Promise((resolve) => {
    this.setState(nextState, resolve);
  });

  isFixedPresetMode = () => String(this.props.presetMode || 'DEFAULT').toUpperCase() === 'FIXED';

  isHistoryEnabled = () => this.props.historyEnabled !== false;

  buildPresetFromModalItem = (item) => {
    if (!item || !item.preset_seq) return null;

    return {
      id: String(item.preset_seq),
      title: item.preset_title || '제목 없는 AI 카피라이터',
      description:
        item.preset_description ||
        item.description ||
        item.memo ||
        item.reference_summary ||
        '저장된 브랜드 톤과 작성 규칙을 적용합니다.',
      defaultYn: item.default_yn || 'N',
      raw: item,
    };
  };

  loadPresetList = async () => {
    this.setState({ isPresetLoading: true });

    try {
      const response = await http.get('/rest/shop/instagram/copywriter/preset/modal/list');
      const rawList = response?.data?.status === 'success' && Array.isArray(response.data.list)
        ? response.data.list
        : [];
      const savedPresetList = rawList.map(this.buildPresetFromModalItem).filter(Boolean);
      const hasSavedDefault = savedPresetList.some((preset) => preset.defaultYn === 'Y');
      const presetList = [
        { ...BASIC_AI_PRESET, defaultYn: hasSavedDefault ? 'N' : 'Y' },
        ...savedPresetList,
      ];

      await this.setStateAsync({ presetList, isPresetLoading: false });
      return presetList;
    } catch (error) {
      console.error('AI 카피라이터 프리셋 목록 조회 실패:', error);
      const presetList = [{ ...BASIC_AI_PRESET, defaultYn: 'Y' }];
      await this.setStateAsync({ presetList, isPresetLoading: false });
      return presetList;
    }
  };

  loadDefaultPreset = async () => {
    const presetList = await this.loadPresetList();
    const selectedPreset = presetList.find((preset) => preset.defaultYn === 'Y') || presetList[0] || BASIC_AI_PRESET;

    await this.setStateAsync({
      selectedPresetId: selectedPreset.id || '',
      selectedPreset,
      presetInitialized: true,
    });

    return selectedPreset;
  };

  loadFixedPreset = async () => {
    const fixedPresetSeq = String(this.props.fixedPresetSeq || '').trim();
    if (!fixedPresetSeq) {
      await this.setStateAsync({
        selectedPresetId: '',
        selectedPreset: { ...BASIC_AI_PRESET },
        presetInitialized: true,
      });
      return null;
    }

    const presetList = await this.loadPresetList();
    let selectedPreset = presetList.find(
      (preset) => String(preset.id || '') === fixedPresetSeq
    ) || null;

    if (!selectedPreset) {
      try {
        const response = await http.get('/rest/shop/instagram/copywriter/preset/info', {
          params: { preset_seq: fixedPresetSeq },
        });
        const item = response?.data?.status === 'success' ? response.data.result : null;
        selectedPreset = item ? {
          id: fixedPresetSeq,
          title: item.preset_title || '선택한 AI 카피라이터',
          description: item.preset_description || '저장된 브랜드 톤과 작성 규칙을 적용합니다.',
          defaultYn: item.default_yn || 'N',
          raw: item,
        } : null;
      } catch (error) {
        console.error('고정 AI 카피라이터 조회 실패:', error);
      }
    }

    if (!selectedPreset) {
      this.showToast('저장한 AI 카피라이터 설정을 불러오지 못했습니다.');
      return null;
    }

    await this.setStateAsync({
      selectedPresetId: selectedPreset.id,
      selectedPreset,
      presetInitialized: true,
    });
    return selectedPreset;
  };

  loadGptUsage = async () => {
    this.setState({ gptUsageLoading: true });

    try {
      const response = await http.get('/rest/shop/ai/usage', {
        params: { service_type: '01014' },
      });
      const data = response?.data || {};

      await this.setStateAsync({
        gptUsageLoading: false,
        gptUsage: {
          total_available_gpt_char_count: Number(data.total_available_gpt_char_count) || 0,
          total_used_gpt_char_count: Number(data.total_used_gpt_char_count) || 0,
          is_api_limit_apply_yn: data.is_api_limit_apply_yn || 'N',
        },
      });
    } catch (error) {
      console.error('GPT 사용량 조회 실패:', error);
      this.setState({ gptUsageLoading: false });
    }
  };

  loadGenerationCount = async () => {
    try {
      const response = await http.get('/rest/shop/instagram/generation-count');
      const data = response?.data?.result || {};
      await this.setStateAsync({
        generationCount: Number(data.manual_caption_count) || 3,
        isAutoHashtagOn:
          data.manual_is_auto_hashtag_on === true ||
          data.manual_is_auto_hashtag_on === 1 ||
          data.manual_is_auto_hashtag_on === '1' ||
          data.manual_is_auto_hashtag_on === 'Y',
        hashtagGenerationCount: Number(data.manual_hashtag_count) || 5,
      });
    } catch (error) {
      console.error('AI 카피라이터 생성 개수 설정 조회 실패:', error);
    }
  };

  // 해당 미디어에 실제로 저장된 copywriter_preset_seq를 초기 선택값으로 보여준다.
  // 히스토리 목록은 변경하지 않으며, 기본 카피라이터 설정(default_yn)도 수정하지 않는다.
  loadMediaPreset = async (presetSeq) => {
    const normalizedSeq = String(presetSeq || '').trim();
    if (!normalizedSeq) return null;

    const presetList = await this.loadPresetList();
    let selectedPreset = presetList.find(
      (preset) => String(preset.id || '') === normalizedSeq
    ) || null;

    // 목록에 없는 설정도 소유권 검사를 수행하는 기존 프리셋 상세 API로 조회한다.
    if (!selectedPreset) {
      try {
        const response = await http.get('/rest/shop/instagram/copywriter/preset/info', {
          params: { preset_seq: normalizedSeq },
        });
        const item = response?.data?.status === 'success' ? response.data.result : null;
        selectedPreset = item ? this.buildPresetFromModalItem({
          ...item,
          preset_seq: normalizedSeq,
        }) : null;
      } catch (error) {
        console.error('미디어에 연결된 AI 카피라이터 조회 실패:', error);
      }
    }

    if (!selectedPreset) {
      // 이미 삭제된 설정을 임의의 기본 카피라이터로 대체하면 실제 미디어 연결과 달라진다.
      await this.setStateAsync({
        selectedPresetId: normalizedSeq,
        selectedPreset: {
          id: normalizedSeq,
          title: '연결된 AI 카피라이터를 찾을 수 없습니다.',
          description: '저장된 카피라이터 설정을 확인해주세요.',
        },
        presetInitialized: true,
      });
      return null;
    }

    await this.setStateAsync({
      selectedPresetId: selectedPreset.id,
      selectedPreset,
      presetInitialized: true,
    });
    return selectedPreset;
  };

  initializeForOpen = async () => {
    const mediaSeq = String(this.getGenerationContext().instagram_media_seq || '').trim();
    const linkedPresetSeq = String(this.props.initialPresetSeq || '').trim();
    const mediaChanged = this.lastOpenedMediaSeq !== undefined &&
      this.lastOpenedMediaSeq !== mediaSeq;
    this.lastOpenedMediaSeq = mediaSeq;

    if (!this.isFixedPresetMode() && mediaSeq && linkedPresetSeq) {
      // 미디어에 연결된 프리셋과 과거에 살펴본 다른 히스토리가 혼동되지 않도록
      // 상세 선택만 초기화한다. 히스토리 목록 자체는 그대로 불러온다.
      this.flushSelectionSave();
      await this.setStateAsync({
        copywriterHistorySeq: null,
        selectedHistorySeq: null,
        selectedHistoryInfo: null,
        isAutoHistory: false,
        historySourceType: 'MANUAL',
        command: this.props.initialCommand || '',
        recommendations: [],
        selectedIndexes: [],
        selectedPresetId: '',
        selectedPreset: null,
        presetInitialized: false,
      });
    }

    const tasks = [this.loadGenerationCount(), this.loadGptUsage()];
    if (this.isHistoryEnabled()) {
      tasks.push(this.loadHistoryList(mediaSeq && linkedPresetSeq ? 'MANUAL' : undefined));
    }
    await Promise.all(tasks);

    // 고정 프리셋으로 실행되는 다른 사용처의 기존 동작을 유지한다.
    if (this.isFixedPresetMode()) {
      await this.loadFixedPreset();
      return;
    }

    // 히스토리 자동 선택 대신, 미디어에 저장된 카피라이터 설정을 선택한다.
    if (mediaSeq && linkedPresetSeq) {
      await this.loadMediaPreset(linkedPresetSeq);
      return;
    }

    if (mediaChanged) {
      await this.startNewHistory();
      return;
    }
    if (!this.state.selectedHistorySeq && !this.state.presetInitialized) {
      await this.loadDefaultPreset();
    }
  };

  handleClose = () => {
    this.stopModalDrag();
    this.clearToastTimer();
    this.flushSelectionSave();
    this.setState({
      isSelectModalOpen: false,
      dragX: 0,
      dragY: 0,
      toastMessage: '',
      historyMenuSeq: null,
      isMobileHistoryOpen: false,
      isHistoryDeleteDialogOpen: false,
      historyDeleteTarget: null,
      isHistoryRenameDialogOpen: false,
      historyRenameTarget: null,
      historyDuplicateSeq: null,
    }, () => {
      if (this.props.onClose) this.props.onClose();
    });
  };

  openSelectModal = (e) => {
    if (this.state.isAutoHistory) return;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.isFixedPresetMode()) return;
    this.setState({ isSelectModalOpen: true });
  };

  closeSelectModal = () => {
    this.setState({ isSelectModalOpen: false });
  };

  handlePresetListLoaded = (presetList = []) => {
    const selectedId = String(this.state.selectedPresetId || '');
    const selectedPreset = (presetList || []).find(
      (item) => String(item.id || '') === selectedId
    ) || null;

    this.setState({
      presetList,
      selectedPreset: selectedPreset || this.state.selectedPreset,
    });
  };

  handlePresetApply = async (selectedId, selectedPreset) => {
    if (this.isFixedPresetMode() || this.state.isAutoHistory) return false;

    try {
      const response = await http.put(
        '/rest/shop/instagram/copywriter/preset/default',
        { preset_seq: selectedId || null },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response?.data?.status !== 'success') {
        throw new Error(response?.data?.message || '기본 카피라이터 설정 저장에 실패했습니다.');
      }

      const nextPreset = selectedPreset || { ...BASIC_AI_PRESET };
      await this.setStateAsync({
        selectedPresetId: selectedId || '',
        selectedPreset: nextPreset,
        presetInitialized: true,
        presetList: (this.state.presetList || []).map((preset) => ({
          ...preset,
          defaultYn: String(preset.id || '') === String(selectedId || '') ? 'Y' : 'N',
        })),
      });

      this.showToast(`${nextPreset.title || '베이직 AI'}를 기본 설정으로 저장했습니다.`);
      return true;
    } catch (error) {
      console.error('AI 카피라이터 기본 설정 저장 실패:', error);
      this.showToast('AI 카피라이터 기본 설정을 저장하지 못했습니다.');
      return false;
    }
  };

  toggleMobileHistory = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.isHistoryEnabled()) return;

    this.setState((prevState) => ({
      isMobileHistoryOpen: !prevState.isMobileHistoryOpen,
      historyMenuSeq: null,
    }));
  };

  closeMobileHistory = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.state.isMobileHistoryOpen) return;
    this.setState({ isMobileHistoryOpen: false, historyMenuSeq: null });
  };

  clearToastTimer = () => {
    if (this.toastTimer) {
      window.clearTimeout(this.toastTimer);
      this.toastTimer = null;
    }
  };

  showToast = (message) => {
    this.clearToastTimer();
    this.setState({ toastMessage: message });
    this.toastTimer = window.setTimeout(() => {
      this.setState({ toastMessage: '' });
      this.toastTimer = null;
    }, 2200);
  };

  getGenerationContext = () => {
    const source = typeof this.props.getGenerationContext === 'function'
      ? (this.props.getGenerationContext() || {})
      : (this.props.generationContext || {});

    const productNameList = source.product_name_list || source.productNameList || [];
    const imageList = source.image_list || source.imageList || [];

    return {
      product_name_list: Array.isArray(productNameList) ? productNameList.filter(Boolean) : [],
      image_list: Array.isArray(imageList) ? imageList.filter(Boolean) : [],
      instagram_media_seq:
        source.instagram_media_seq ||
        source.instagramMediaSeq ||
        source.media_id ||
        source.mediaId ||
        null,
    };
  };

  generateCopywriterRecommendations = async () => {
    if (this.state.isGenerating || this.state.isAutoHistory) return;

    const selectedPresetId = this.state.selectedPresetId || '';
    const selectedPreset = this.state.selectedPreset;
    const command = this.state.command || '';
    const effectiveCommand = this.getEffectiveCommand();
    const createCount = Number(this.state.generationCount) || 3;
    const context = this.getGenerationContext();

    this.setState({ isGenerating: true });

    try {
      const { data } = await http.post(
        '/rest/shop/instagram/GptRecommamdSentence',
        {
          create_cnt: createCount,
          product_name_list: context.product_name_list,
          user_prompt: effectiveCommand,
          copywriter_preset_seq: selectedPresetId || null,
          image_list: context.image_list,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const currentRecommendations = Array.isArray(this.state.recommendations)
        ? this.state.recommendations
        : [];
      const startIndex = currentRecommendations.length;
      const generatedRecommendations = Array.isArray(data?.recommendations)
        ? data.recommendations.map((item, index) => ({
            ...item,
            label: item?.label || `추천 문구 ${startIndex + index + 1}`,
            text: item?.text || '',
          }))
        : [];

      if (generatedRecommendations.length === 0) {
        throw new Error('생성된 추천 문구가 없습니다.');
      }

      let nextHistorySeq = this.state.copywriterHistorySeq || null;
      let persistedRecommendations = generatedRecommendations;

      try {
        const historyResponse = await http.post(
          '/rest/shop/instagram/copywriter/history/run',
          {
            copywriter_history_seq: nextHistorySeq,
            instagram_media_seq: context.instagram_media_seq,
            user_prompt: command,
            copywriter_preset_seq: selectedPresetId || null,
            copywriter_preset_title: selectedPreset?.title || (selectedPresetId ? '선택한 AI 카피라이터' : '베이직 AI'),
            create_cnt: createCount,
            auto_hashtag_yn: this.state.isAutoHashtagOn ? 'Y' : 'N',
            hashtag_count: Number(this.state.hashtagGenerationCount) || 0,
            product_name_list: context.product_name_list,
            image_list: context.image_list,
            gpt_call_seq: data?.gpt_call_seq || null,
            recommendations: generatedRecommendations,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );

        if (historyResponse?.data?.status === 'success') {
          nextHistorySeq = historyResponse.data.copywriter_history_seq || nextHistorySeq;
          const savedResults = Array.isArray(historyResponse.data.result_list)
            ? historyResponse.data.result_list
            : [];

          persistedRecommendations = generatedRecommendations.map((item, index) => ({
            ...item,
            copywriter_history_seq: nextHistorySeq,
            copywriter_history_run_seq:
              savedResults[index]?.copywriter_history_run_seq ||
              historyResponse.data.copywriter_history_run_seq ||
              null,
            copywriter_history_result_seq:
              savedResults[index]?.copywriter_history_result_seq || null,
            run_no: savedResults[index]?.run_no || historyResponse.data.run_no || null,
            result_no: savedResults[index]?.result_no || index + 1,
            selected_yn: 'N',
            applied_yn: 'N',
          }));
        }
      } catch (historyError) {
        console.error('AI 카피라이터 히스토리 저장 실패:', historyError);
      }

      await this.setStateAsync((prevState) => ({
        recommendations: [
          ...(Array.isArray(prevState.recommendations) ? prevState.recommendations : []),
          ...persistedRecommendations,
        ],
        selectedIndexes: prevState.selectedIndexes || [],
        isGenerating: false,
        copywriterHistorySeq: nextHistorySeq,
        selectedHistorySeq: nextHistorySeq,
      }));

      if (this.isHistoryEnabled() && nextHistorySeq) {
        this.loadHistoryList();
      }
      this.loadGptUsage();

      if (this.props.onGenerated) {
        this.props.onGenerated({ data, recommendations: persistedRecommendations, copywriterHistorySeq: nextHistorySeq });
      }
    } catch (error) {
      console.error('AI 추천문 생성 실패:', error);
      this.setState({ isGenerating: false });
      this.showToast('추천 문장 생성에 실패했습니다. 잠시 후 다시 시도해주세요.');
    }
  };

  getSelectedRecommendations = () => {
    const recommendations = this.state.recommendations || [];
    const selectedIndexes = this.state.selectedIndexes || [];

    return selectedIndexes
      .slice()
      .sort((a, b) => a - b)
      .map((index) => recommendations[index])
      .filter((item) => item && String(item.text || '').trim());
  };

  getMergedCaption = () => this.getSelectedRecommendations()
    .map((item) => String(item.text || '').trim())
    .join('\n\n');

  getApplyTargetLabel = () => String(
    this.props.applyTargetLabel || '문구 작성 에디터'
  ).trim() || '문구 작성 에디터';

  getCurrentCopywriterContext = (selectedRecommendations = []) => {
    const recommendationHistorySeq = (selectedRecommendations || [])
      .map((item) => item?.copywriter_history_seq)
      .find(Boolean);

    const copywriterPresetSeq = String(
      this.state.selectedPresetId || ''
    ).trim();

    return {
      copywriter_preset_seq: copywriterPresetSeq || null,
      copywriter_preset_title:
        this.state.selectedPreset?.title ||
        (copywriterPresetSeq ? '선택한 AI 카피라이터' : '베이직 AI'),
      copywriter_history_seq:
        this.state.copywriterHistorySeq ||
        this.state.selectedHistorySeq ||
        recommendationHistorySeq ||
        null,
    };
  };

  getEffectiveCommand = () => {
    const generationInstruction = String(this.props.generationInstruction || '').trim();
    const command = String(this.state.command || '').trim();

    return [generationInstruction, command].filter(Boolean).join('\n\n');
  };

  handleApply = async () => {
    const selectedRecommendations = this.getSelectedRecommendations();
    const applyTargetLabel = this.getApplyTargetLabel();
    if (selectedRecommendations.length === 0) {
      this.showToast(`${applyTargetLabel}에 적용할 문구를 하나 이상 선택해주세요.`);
      return;
    }

    const mergedCaption = selectedRecommendations
      .map((item) => String(item.text || '').trim())
      .join('\n\n');

    if (!this.props.onApply) return;

    const applyResult = await this.props.onApply(
      mergedCaption,
      selectedRecommendations,
      this.getCurrentCopywriterContext(selectedRecommendations)
    );

    if (
      applyResult === false ||
      (applyResult && applyResult.applied === false)
    ) {
      return;
    }

    if (applyResult?.refreshGptUsage === true) {
      await this.loadGptUsage();
    }

    this.saveApplyState(mergedCaption, selectedRecommendations);
    const selectedSet = new Set(this.state.selectedIndexes || []);
    let appliedOrder = 0;
    this.setState((prev) => ({
      recommendations: (prev.recommendations || []).map((item, index) => {
        if (selectedSet.has(index)) {
          appliedOrder += 1;
          return { ...item, applied_yn: 'Y', applied_order: appliedOrder };
        }
        return { ...item, applied_yn: 'N', applied_order: null };
      }),
    }), () => {
      if (this.props.closeOnApply) {
        this.handleClose();
        return;
      }
      this.showToast(`선택한 문구를 ${applyTargetLabel}에 적용했습니다.`);
    });
  };

  handleContentRegister = async () => {
    const selectedRecommendations = this.getSelectedRecommendations();

    if (selectedRecommendations.length === 0) {
      this.showToast('콘텐츠에 사용할 문구를 하나 이상 선택해주세요.');
      return;
    }

    if (!this.props.onContentRegister) {
      return;
    }

    const mergedCaption = selectedRecommendations
      .map((item) => String(item.text || '').trim())
      .join('\n\n');

    // 콘텐츠 등록 화면으로 이동하기 전에 선택/적용 히스토리를 먼저 저장합니다.
    await this.saveApplyState(mergedCaption, selectedRecommendations);

    const registerResult = await this.props.onContentRegister(
      mergedCaption,
      selectedRecommendations,
      this.getCurrentCopywriterContext(selectedRecommendations)
    );

    if (
      registerResult === false ||
      (registerResult && registerResult.applied === false)
    ) {
      return;
    }

    if (registerResult?.refreshGptUsage === true) {
      await this.loadGptUsage();
    }
  };

  handleCopy = async () => {
    const mergedCaption = this.getMergedCaption();
    if (!mergedCaption) {
      this.showToast('복사할 문구를 하나 이상 선택해주세요.');
      return;
    }

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(mergedCaption);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = mergedCaption;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      this.showToast('선택한 문구를 복사했습니다.');
    } catch (error) {
      console.error('선택 문구 복사 실패:', error);
      this.showToast('문구를 복사하지 못했습니다.');
    }
  };

  handleClearSelection = () => {
    if ((this.state.selectedIndexes || []).length === 0) return;
    this.setState({ selectedIndexes: [] }, this.scheduleSelectionSave);
  };

  toggleRecommendationSelection = (index) => {
    this.setState((prev) => {
      const selected = new Set(prev.selectedIndexes || []);
      if (selected.has(index)) selected.delete(index);
      else selected.add(index);
      return { selectedIndexes: Array.from(selected).sort((a, b) => a - b) };
    }, this.scheduleSelectionSave);
  };

  handleOpenCaptionSettings = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.props.onOpenCaptionSettings) {
      this.props.onOpenCaptionSettings();
    } else {
      window.open('/shop/instagram/InstagramCreateCntSetting');
    }
  };

  handleCaptionSettingsKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') this.handleOpenCaptionSettings(e);
  };

  loadHistoryList = async (sourceType = this.state.historySourceType || 'MANUAL') => {
    if (!this.isHistoryEnabled()) return [];

    const normalizedSourceType = String(sourceType || 'MANUAL').toUpperCase() === 'AUTO'
      ? 'AUTO'
      : 'MANUAL';

    this.setState({ isHistoryLoading: true });
    try {
      const response = await http.get('/rest/shop/instagram/copywriter/history/list', {
        params: { source_type: normalizedSourceType },
      });
      const historyItems = response?.data?.status === 'success' && Array.isArray(response.data.history_list)
        ? response.data.history_list
        : [];
      await this.setStateAsync({
        historyItems,
        historySourceType: normalizedSourceType,
        isHistoryLoading: false,
      });
      return historyItems;
    } catch (error) {
      console.error('AI 카피라이터 히스토리 목록 조회 실패:', error);
      await this.setStateAsync({ historyItems: [], isHistoryLoading: false });
      return [];
    }
  };

  handleHistorySourceChange = async (sourceType) => {
    if (this.state.isGenerating || this.state.isHistoryDetailLoading) return;

    const normalizedSourceType = String(sourceType || 'MANUAL').toUpperCase() === 'AUTO'
      ? 'AUTO'
      : 'MANUAL';

    const currentSourceType = String(
      this.state.selectedHistoryInfo?.source_type || (this.state.isAutoHistory ? 'AUTO' : 'MANUAL')
    ).toUpperCase();

    this.flushSelectionSave();
    this.setState({
      historySourceType: normalizedSourceType,
      historyMenuSeq: null,
    });

    const historyItems = await this.loadHistoryList(normalizedSourceType);

    if (currentSourceType === normalizedSourceType && this.state.selectedHistorySeq) return;

    if (historyItems.length > 0) {
      await this.loadHistoryDetail(historyItems[0].copywriter_history_seq);
      return;
    }

    if (normalizedSourceType === 'MANUAL') {
      await this.startNewHistory();
      return;
    }

    await this.setStateAsync({
      copywriterHistorySeq: null,
      selectedHistorySeq: null,
      selectedHistoryInfo: null,
      isAutoHistory: true,
      command: '',
      selectedPresetId: '',
      selectedPreset: null,
      presetInitialized: true,
      recommendations: [],
      selectedIndexes: [],
      isMobileHistoryOpen: false,
      historyMenuSeq: null,
    });
  };

  loadHistoryDetail = async (copywriterHistorySeq) => {
    if (!copywriterHistorySeq || this.state.isGenerating || !this.isHistoryEnabled()) return;
    this.flushSelectionSave();
    this.setState({ isHistoryDetailLoading: true });

    try {
      const response = await http.get('/rest/shop/instagram/copywriter/history/detail', {
        params: { copywriter_history_seq: copywriterHistorySeq },
      });
      if (response?.data?.status !== 'success') {
        throw new Error(response?.data?.message || '히스토리를 불러오지 못했습니다.');
      }

      const historyInfo = response.data.history_info || {};
      const latestRun = response.data.latest_run || {};
      const sourceType = String(historyInfo.source_type || 'MANUAL').toUpperCase();
      const isAutoHistory = sourceType === 'AUTO';
      const resultList = Array.isArray(response.data.result_list) ? response.data.result_list : [];
      const recommendations = resultList.map((item, index) => ({
        label: item.label || `추천 문구 ${index + 1}`,
        text: item.result_text || '',
        copywriter_history_seq: item.copywriter_history_seq,
        copywriter_history_run_seq: item.copywriter_history_run_seq,
        copywriter_history_result_seq: item.copywriter_history_result_seq,
        run_no: item.run_no,
        result_no: item.result_no,
        selected_yn: item.is_selected_yn || 'N',
        applied_yn: item.is_applied_yn || 'N',
        applied_order: item.applied_order,
      }));
      const selectedIndexes = isAutoHistory
        ? []
        : recommendations
          .map((item, index) => item.selected_yn === 'Y' ? index : -1)
          .filter((index) => index >= 0);
      const presetSeq = latestRun.copywriter_preset_seq ? String(latestRun.copywriter_preset_seq) : '';
      const selectedPreset = presetSeq
        ? { id: presetSeq, title: latestRun.copywriter_preset_title || '선택한 AI 카피라이터' }
        : { ...BASIC_AI_PRESET };

      await this.setStateAsync({
        copywriterHistorySeq: historyInfo.copywriter_history_seq || copywriterHistorySeq,
        selectedHistorySeq: historyInfo.copywriter_history_seq || copywriterHistorySeq,
        historySourceType: sourceType === 'AUTO' ? 'AUTO' : 'MANUAL',
        selectedHistoryInfo: historyInfo,
        isAutoHistory,
        command: isAutoHistory ? '' : (latestRun.user_prompt || ''),
        selectedPresetId: presetSeq,
        selectedPreset,
        presetInitialized: true,
        recommendations,
        selectedIndexes,
        generationCount: Number(latestRun.create_cnt) || this.state.generationCount || 3,
        isAutoHashtagOn: latestRun.auto_hashtag_yn === 'Y',
        hashtagGenerationCount: Number(latestRun.hashtag_count) || 0,
        isHistoryDetailLoading: false,
        isMobileHistoryOpen: false,
      });
    } catch (error) {
      console.error('AI 카피라이터 히스토리 상세 조회 실패:', error);
      this.setState({ isHistoryDetailLoading: false });
      this.showToast('카피라이터 히스토리를 불러오지 못했습니다.');
    }
  };

  startNewHistory = async () => {
    this.flushSelectionSave();
    await this.setStateAsync({
      copywriterHistorySeq: null,
      selectedHistorySeq: null,
      historySourceType: 'MANUAL',
      selectedHistoryInfo: null,
      isAutoHistory: false,
      command: this.props.initialCommand || '',
      selectedPresetId: '',
      selectedPreset: null,
      presetInitialized: false,
      recommendations: [],
      selectedIndexes: [],
      isMobileHistoryOpen: false,
      historyMenuSeq: null,
    });
    await this.loadGenerationCount();
    if (this.isFixedPresetMode()) await this.loadFixedPreset();
    else await this.loadDefaultPreset();
    if (this.isHistoryEnabled()) await this.loadHistoryList('MANUAL');
  };

  renameHistory = async (copywriterHistorySeq, historyTitle) => {
    const normalizedTitle = String(historyTitle || '').trim();
    if (!copywriterHistorySeq || !normalizedTitle) return;
    try {
      const response = await http.put('/rest/shop/instagram/copywriter/history/title', {
        copywriter_history_seq: copywriterHistorySeq,
        history_title: normalizedTitle,
      });
      if (response?.data?.status !== 'success') throw new Error(response?.data?.message || '이름 변경 실패');
      this.loadHistoryList();
    } catch (error) {
      console.error('AI 카피라이터 히스토리 이름 변경 실패:', error);
      this.showToast('카피라이터 히스토리 이름을 변경하지 못했습니다.');
    }
  };

  duplicateHistory = async (historyItem) => {
    const copywriterHistorySeq = historyItem?.copywriter_history_seq;
    if (!copywriterHistorySeq || this.state.historyDuplicateSeq) return;

    this.setState({
      historyMenuSeq: null,
      historyDuplicateSeq: copywriterHistorySeq,
    });

    try {
      const response = await http.post(
        `/rest/shop/instagram/copywriter/history/${encodeURIComponent(copywriterHistorySeq)}/duplicate`
      );
      if (response?.data?.status !== 'success') {
        throw new Error(response?.data?.message || '새 작업 복제에 실패했습니다.');
      }

      const newHistorySeq = response.data.copywriter_history_seq;
      await this.loadHistoryList('MANUAL');
      await this.setStateAsync({ historyDuplicateSeq: null });
      await this.loadHistoryDetail(newHistorySeq);
      this.showToast('새 작업으로 복제되었습니다.');
    } catch (error) {
      console.error('AI 카피라이터 새 작업 복제 실패:', error);
      this.setState({ historyDuplicateSeq: null });
      this.showToast(error?.response?.data?.message || error?.message || '새 작업으로 복제하지 못했습니다.');
    }
  };

  deleteHistory = async (copywriterHistorySeq) => {
    if (!copywriterHistorySeq) return;
    try {
      const deletingSelectedHistory =
        String(this.state.copywriterHistorySeq || '') === String(copywriterHistorySeq);
      const deletingSourceType = String(
        this.state.selectedHistoryInfo?.source_type || this.state.historySourceType || 'MANUAL'
      ).toUpperCase() === 'AUTO' ? 'AUTO' : 'MANUAL';

      const response = await http.delete(`/rest/shop/instagram/copywriter/history/${copywriterHistorySeq}`);
      if (response?.data?.status !== 'success') throw new Error(response?.data?.message || '삭제 실패');

      if (!deletingSelectedHistory) {
        await this.loadHistoryList(deletingSourceType);
        return;
      }

      if (deletingSourceType === 'MANUAL') {
        await this.startNewHistory();
        return;
      }

      const historyItems = await this.loadHistoryList('AUTO');
      if (historyItems.length > 0) {
        await this.loadHistoryDetail(historyItems[0].copywriter_history_seq);
        return;
      }

      await this.setStateAsync({
        copywriterHistorySeq: null,
        selectedHistorySeq: null,
        selectedHistoryInfo: null,
        isAutoHistory: true,
        command: '',
        selectedPresetId: '',
        selectedPreset: null,
        presetInitialized: true,
        recommendations: [],
        selectedIndexes: [],
        historyMenuSeq: null,
      });
    } catch (error) {
      console.error('AI 카피라이터 히스토리 삭제 실패:', error);
      this.showToast('카피라이터 히스토리를 삭제하지 못했습니다.');
    }
  };

  getHistoryResultSeq = (recommendation) => recommendation && (
    recommendation.copywriter_history_result_seq ||
    recommendation.history_result_seq ||
    recommendation.result_seq ||
    null
  );

  saveSelectionState = () => {
    if (this.state.isAutoHistory) return Promise.resolve();
    const historySeq = this.state.copywriterHistorySeq;
    if (!historySeq) return Promise.resolve();
    const selectedIndexes = this.state.selectedIndexes || [];
    const recommendations = this.state.recommendations || [];
    const selectedResultSeqList = selectedIndexes
      .map((index) => this.getHistoryResultSeq(recommendations[index]))
      .filter(Boolean);

    if (selectedIndexes.length > 0 && selectedResultSeqList.length !== selectedIndexes.length) {
      return Promise.resolve();
    }

    return http.put('/rest/shop/instagram/copywriter/history/selection', {
      copywriter_history_seq: historySeq,
      selected_result_seq_list: selectedResultSeqList,
    }).catch((error) => console.error('AI 카피라이터 선택 상태 저장 실패:', error));
  };

  scheduleSelectionSave = (delay = 650) => {
    if (this.copywriterSelectionSaveTimer) window.clearTimeout(this.copywriterSelectionSaveTimer);
    this.copywriterSelectionSaveTimer = window.setTimeout(() => {
      this.copywriterSelectionSaveTimer = null;
      this.saveSelectionState();
    }, delay);
  };

  flushSelectionSave = () => {
    if (!this.copywriterSelectionSaveTimer) return;
    window.clearTimeout(this.copywriterSelectionSaveTimer);
    this.copywriterSelectionSaveTimer = null;
    this.saveSelectionState();
  };

  saveApplyState = (appliedText, selectedRecommendations = []) => {
    if (this.state.isAutoHistory) return Promise.resolve();
    const historySeq = this.state.copywriterHistorySeq;
    if (!historySeq) return Promise.resolve();
    const appliedResults = selectedRecommendations
      .map((item, index) => ({
        copywriter_history_result_seq: this.getHistoryResultSeq(item),
        applied_order: index + 1,
      }))
      .filter((item) => item.copywriter_history_result_seq);
    if (appliedResults.length === 0) return Promise.resolve();

    return http.put('/rest/shop/instagram/copywriter/history/apply', {
      copywriter_history_seq: historySeq,
      applied_text: appliedText,
      applied_results: appliedResults,
    }).then(() => {
      if (this.isHistoryEnabled()) this.loadHistoryList();
    }).catch((error) => console.error('AI 카피라이터 적용 상태 저장 실패:', error));
  };

  getHistoryGroupLabel = (value) => {
    if (!value) return '이전';
    const date = new Date(String(value).replace(' ', 'T'));
    if (Number.isNaN(date.getTime())) return '이전';
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const dayDiff = Math.round((today.getTime() - target.getTime()) / 86400000);
    if (dayDiff === 0) return '오늘';
    if (dayDiff === 1) return '어제';
    return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
  };

  groupHistoryItems = (historyItems = []) => (historyItems || []).reduce((groups, item) => {
    const groupLabel = this.getHistoryGroupLabel(item.mod_date || item.reg_date);
    if (!groups[groupLabel]) groups[groupLabel] = [];
    groups[groupLabel].push(item);
    return groups;
  }, {});

  toggleHistoryMenu = (event, historyItem) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    const historySeq = historyItem && historyItem.copywriter_history_seq;
    this.setState((prev) => ({
      historyMenuSeq: String(prev.historyMenuSeq || '') === String(historySeq || '') ? null : historySeq,
    }));
  };

  handleHistoryRename = (event, historyItem) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!historyItem) return;

    this.setState({
      historyMenuSeq: null,
      isHistoryRenameDialogOpen: true,
      historyRenameTarget: historyItem,
    });
  };

  closeHistoryRenameDialog = () => {
    this.setState({
      isHistoryRenameDialogOpen: false,
      historyRenameTarget: null,
    });
  };

  confirmHistoryRename = async (inputValues = []) => {
    const historyItem = this.state.historyRenameTarget;
    const copywriterHistorySeq = historyItem?.copywriter_history_seq;
    const currentTitle = String(historyItem?.history_title || '새 문구 생성').trim();
    const normalizedTitle = String(inputValues[0] || '').trim();

    if (!copywriterHistorySeq) {
      this.closeHistoryRenameDialog();
      return;
    }

    if (!normalizedTitle) {
      this.showToast('변경할 히스토리 이름을 입력해주세요.');
      return;
    }

    this.closeHistoryRenameDialog();
    if (normalizedTitle === currentTitle) return;

    await this.renameHistory(copywriterHistorySeq, normalizedTitle);
  };

  closeHistoryDeleteDialog = () => {
    this.setState({
      isHistoryDeleteDialogOpen: false,
      historyDeleteTarget: null,
    });
  };

  confirmHistoryDelete = () => {
    const historyItem = this.state.historyDeleteTarget;
    const copywriterHistorySeq = historyItem?.copywriter_history_seq;

    this.closeHistoryDeleteDialog();
    if (!copywriterHistorySeq) return;

    this.deleteHistory(copywriterHistorySeq);
  };

  handleHistoryDelete = (event, historyItem) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!historyItem) return;

    this.setState({
      historyMenuSeq: null,
      isHistoryDeleteDialogOpen: true,
      historyDeleteTarget: historyItem,
    });
  };

  handleHistoryDuplicate = (event, historyItem) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!historyItem || this.state.historyDuplicateSeq) return;
    this.duplicateHistory(historyItem);
  };

  startModalDrag = (e) => {
    if (e.button !== 0) return;
    if (e.target.closest('button, a, input, textarea, select, label')) return;

    const modal = this.modalRef.current;
    if (!modal) return;

    const rect = modal.getBoundingClientRect();
    this.dragContext = {
      startClientX: e.clientX,
      startClientY: e.clientY,
      startDragX: this.state.dragX || 0,
      startDragY: this.state.dragY || 0,
      startRect: rect,
    };

    document.addEventListener('mousemove', this.handleModalDrag);
    document.addEventListener('mouseup', this.stopModalDrag);
    e.preventDefault();
  };

  handleModalDrag = (e) => {
    const drag = this.dragContext;
    if (!drag) return;

    const rawDx = e.clientX - drag.startClientX;
    const rawDy = e.clientY - drag.startClientY;

    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;

    const margin = 6;
    const visibleHeaderHeight = 40;

    // 모달 너비의 65%까지 좌우 화면 밖으로 이동 허용
    const horizontalOverflow = drag.startRect.width * 0.65;

    const minLeft = margin - horizontalOverflow;
    const maxLeft =
      viewportWidth -
      drag.startRect.width +
      horizontalOverflow -
      margin;

    const nextLeft = Math.min(
      maxLeft,
      Math.max(minLeft, drag.startRect.left + rawDx)
    );

    const minTop = margin;
    const maxTop = Math.max(
      margin,
      viewportHeight - visibleHeaderHeight
    );

    const nextTop = Math.min(
      maxTop,
      Math.max(minTop, drag.startRect.top + rawDy)
    );

    this.setState({
      dragX:
        drag.startDragX +
        (nextLeft - drag.startRect.left),
      dragY:
        drag.startDragY +
        (nextTop - drag.startRect.top),
    });
  };

  stopModalDrag = () => {
    document.removeEventListener('mousemove', this.handleModalDrag);
    document.removeEventListener('mouseup', this.stopModalDrag);
    this.dragContext = null;
  };

  renderResultItem = (recommendation, index) => {
    const selectedIndexes = this.state.selectedIndexes || [];
    const isSelected = selectedIndexes.includes(index);
    const isApplied = recommendation && (
      recommendation.applied_yn === 'Y' ||
      recommendation.is_applied_yn === 'Y'
    );
    const isAutoHistory = !!this.state.isAutoHistory;

    return (
      <article
        key={`${recommendation.label || 'recommendation'}-${index}`}
        className={`robomd-copywriter-result-card ${isSelected ? 'selected' : ''} ${isApplied ? 'applied' : ''}`}
        onClick={() => this.toggleRecommendationSelection(index)}
      >
        <div className="robomd-copywriter-result-card-header">
          <label
            className="robomd-copywriter-result-check-wrap"
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={() => this.toggleRecommendationSelection(index)}
            />
            <span>{index + 1}. {recommendation.label || `추천 문구`}</span>
            {isApplied ? <span className="robomd-copywriter-applied-badge">{isAutoHistory ? '자동화 적용됨' : '적용됨'}</span> : null}
          </label>
        </div>

        <div
          className="robomd-copywriter-result-text"
          onClick={(e) => e.stopPropagation()}
        >
          {recommendation.text || ''}
        </div>
      </article>
    );
  };

  render() {
    if (!this.props.isOpen) return null;

    const {
      isSelectModalOpen,
      dragX,
      dragY,
      toastMessage,
      historyMenuSeq,
      isMobileHistoryOpen,
      isHistoryDeleteDialogOpen,
      isHistoryRenameDialogOpen,
      historyRenameTarget,
      historyDuplicateSeq,
      selectedPresetId,
      selectedPreset,
      command,
      recommendations = [],
      selectedIndexes = [],
      isGenerating,
      generationCount,
      isAutoHashtagOn,
      hashtagGenerationCount,
      historyItems = [],
      historySourceType,
      selectedHistorySeq,
      selectedHistoryInfo,
      isAutoHistory,
      isHistoryLoading,
      isHistoryDetailLoading,
      isPresetLoading,
      gptUsageLoading,
      gptUsage,
    } = this.state;

    const fixedPresetMode = this.isFixedPresetMode();
    const historyEnabled = this.isHistoryEnabled();
    const hasSelectedAutoHistory = !!(isAutoHistory && selectedHistoryInfo?.copywriter_history_seq);
    const selectedTitle = isAutoHistory && !hasSelectedAutoHistory
      ? '자동 히스토리를 선택해주세요'
      : (selectedPreset?.title || (selectedPresetId ? '선택한 AI 카피라이터' : '베이직 AI'));
    const selectedCount = selectedIndexes.length;
    const createCount = generationCount || 3;
    const autoHashtagEnabled = !!isAutoHashtagOn;
    const hashtagCount = Number(hashtagGenerationCount) || 0;
    const hasResults = recommendations.length > 0;
    const groupedHistory = this.groupHistoryItems(historyItems);
    const isAutoHistoryList = historySourceType === 'AUTO';
    const automationTypeLabel = selectedHistoryInfo?.automation_type === 'PRODUCT'
      ? '상품 자동화'
      : selectedHistoryInfo?.automation_type === 'AI_IMAGE'
        ? 'AI 이미지 자동화'
        : '-';
    const automationSettingTitle = selectedHistoryInfo?.automation_setting_title || '-';

    return (
      <>
        <style>{`
          #RoboMDAICopywriterModal {
            --studio-navy: #0d1b2f;
            --studio-mint: #00e2e6;
            --studio-mint-deep: #19bfc3;
            --studio-line: #dce4eb;
            --studio-bg: #f3f7fa;
            --studio-panel: #f7fafc;
            --studio-text: #1f2937;
            --studio-subtext: #7d8996;
            font-family: inherit;
          }

          #RoboMDAICopywriterModal.robomd-copywriter-overlay {
            position: fixed !important;
            inset: 0 !important;
            z-index: 9999 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 16px !important;
            background: ${getCopywriterBackdropColor()} !important;
            pointer-events: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-modal {
            position: fixed !important;
            left: 50% !important;
            top: 50% !important;
            width: min(1420px, calc(100vw - 24px)) !important;
            height: min(780px, calc(100vh - 24px)) !important;
            max-width: none !important;
            max-height: none !important;
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
            margin: 0 !important;
            padding: 0 !important;
            // border: 1px solid #8b939d !important;
            border-radius: 12px !important;
            background: #fff !important;
            box-shadow: 0 7px 22px rgba(15, 23, 42, .28) !important;
            pointer-events: auto !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-header {
            flex: 0 0 66px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 12px !important;
            height: 66px !important;
            min-height: 66px !important;
            margin: 0 !important;
            padding: 0 22px !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: var(--studio-navy) !important;
            color: #fff !important;
            cursor: move !important;
            user-select: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-brand {
            min-width: 0 !important;
            display: flex !important;
            align-items: center !important;
            gap: 13px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-brand-mark {
            width: 27px !important;
            height: 27px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            flex: 0 0 27px !important;
            // border: 2px solid var(--studio-mint) !important;
            border-radius: 50% !important;
            color: var(--studio-mint) !important;
            // font-size: 15px !important;
            font-weight: 900 !important;
            line-height: 1 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-title {
            margin: 0 !important;
            overflow: hidden !important;
            color: #fff !important;
            font-size: 23px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-close {
            width: 38px !important;
            height: 38px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            flex: 0 0 38px !important;
            margin: 0 !important;
            padding: 0 0 0.1rem 0 !important;
            border: 0 !important;
            border-radius: 7px !important;
            background: transparent !important;
            color: #fff !important;
            font-size: 26px !important;
            font-weight: 300 !important;
            line-height: 1 !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-close:hover {
            background: rgba(255, 255, 255, .1) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-body {
            min-height: 0 !important;
            flex: 1 1 auto !important;
            display: grid !important;
            grid-template-columns: 230px 1fr !important;
            margin: 66px 0 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
            background: var(--studio-bg) !important;
          }


          #RoboMDAICopywriterModal .robomd-copywriter-body.no-history {
            grid-template-columns: 1fr !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-inner {
            width: 100% !important;
            height: 100% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-inner-body {
            min-width: 0 !important;
            min-height: 0 !important;
            flex: 1 1 auto !important;
            display: grid !important;
            grid-template-columns: minmax(0, 54%) minmax(0, 46%) !important;
            overflow: hidden !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-sidebar {
            min-width: 0 !important;
            min-height: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            border-right: 1px solid var(--studio-line) !important;
            background: #fff !important;
            overflow: hidden !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-header {
            flex: 0 0 auto !important;
            padding: 16px 14px 12px !important;
            border-bottom: 1px solid var(--studio-line) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-filter-wrap {
            flex: 0 0 auto !important;
            display: flex !important;
            gap: 8px !important;
            padding: 12px 16px !important;
            border-bottom: 1px solid var(--studio-line) !important;
            background: #fff !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-filter-button {
            min-width: 0 !important;
            flex: 1 1 0 !important;
            height: 36px !important;
            padding: 0 8px !important;
            border: 1px solid var(--studio-line) !important;
            border-radius: 8px !important;
            background: #fff !important;
            color: #64748b !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            cursor: pointer !important;
            transition: all .2s ease !important;
            white-space: nowrap !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-filter-button:hover {
            border-color: var(--studio-mint) !important;
            background: #f8fafc !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-filter-button.active {
            border-color: var(--studio-mint) !important;
            background: #ecfeff !important;
            color: #0369a1 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-filter-button:disabled {
            opacity: .55 !important;
            cursor: not-allowed !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-new-history-button {
            width: 100% !important;
            min-height: 42px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 10px !important;
            padding: 12px 14px !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 7px !important;
            background: #fff !important;
            color: var(--studio-navy) !important;
            font-size: 15px !important;
            font-weight: 700 !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-new-history-button:hover {
            border-color: var(--studio-mint) !important;
            background: #f0fdfe !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-list {
            min-height: 0 !important;
            flex: 1 1 auto !important;
            overflow-x: hidden !important;
            overflow-y: auto !important;
            padding: 8px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-group-title {
            padding: 10px 8px 5px !important;
            color: #94a3b8 !important;
            font-size: 11px !important;
            font-weight: 800 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-item {
            width: 100% !important;
            min-width: 0 !important;
            min-height: 38px !important;
            display: flex !important;
            align-items: center !important;
            gap: 5px !important;
            margin: 0 0 3px !important;
            padding: 8px 8px 8px 10px !important;
            border: 0 !important;
            border-radius: 7px !important;
            background: transparent !important;
            color: #334155 !important;
            text-align: left !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-item:hover,
          #RoboMDAICopywriterModal .robomd-copywriter-history-item.active {
            background: #e6fbfc !important;
            color: #087f83 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-item.disabled {
            opacity: .55 !important;
            pointer-events: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-auto-badge {
            flex: 0 0 auto !important;
            padding: 2px 5px !important;
            border: 1px solid #8be8eb !important;
            border-radius: 4px !important;
            background: #eaffff !important;
            color: #087f83 !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            line-height: 1.2 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-header-actions {
            flex: 0 0 auto !important;
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-item-text {
            min-width: 0 !important;
            flex: 1 1 auto !important;
            overflow: hidden !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            line-height: 1.35 !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu-wrap {
            position: relative !important;
            flex: 0 0 auto !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu-trigger {
            width: 25px !important;
            height: 25px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 5px !important;
            background: transparent !important;
            color: #94a3b8 !important;
            font-size: 17px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu-trigger:hover {
            background: #fff !important;
            color: var(--studio-navy) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu {
            position: absolute !important;
            top: 28px !important;
            right: 0 !important;
            z-index: 20 !important;
            min-width: 128px !important;
            padding: 5px !important;
            border: 1px solid #dbe3ea !important;
            border-radius: 7px !important;
            background: #fff !important;
            box-shadow: 0 8px 22px rgba(15, 23, 42, .16) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu button {
            width: 100% !important;
            display: block !important;
            padding: 7px 9px !important;
            border: 0 !important;
            border-radius: 5px !important;
            background: transparent !important;
            color: #475569 !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            text-align: left !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu button:hover {
            background: #f1f5f9 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu button:disabled {
            opacity: .55 !important;
            cursor: not-allowed !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-menu button.delete {
            color: #dc2626 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-delete {
            width: 24px !important;
            height: 24px !important;
            flex: 0 0 24px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 5px !important;
            background: transparent !important;
            color: #94a3b8 !important;
            font-size: 15px !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-delete:hover {
            background: #fff !important;
            color: #dc2626 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-history-empty {
            padding: 15px 10px !important;
            color: #94a3b8 !important;
            font-size: 12px !important;
            line-height: 1.5 !important;
            text-align: center !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-builder {
            min-width: 0 !important;
            min-height: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            gap: 18px !important;
            margin: 0 !important;
            padding: 24px !important;
            overflow-x: hidden !important;
            overflow-y: auto !important;
            border-right: 1px solid var(--studio-line) !important;
            background: #f6f8fa !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-form-card {
            flex: 0 0 auto !important;
            margin: 0 !important;
            padding: 18px 20px !important;
            border: 1px solid #dce3e9 !important;
            border-radius: 14px !important;
            background: #fff !important;
            box-shadow: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-step-title {
            display: flex !important;
            align-items: flex-start !important;
            gap: 11px !important;
            margin: 0 0 14px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-step-badge {
            width: 22px !important;
            height: 22px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            flex: 0 0 22px !important;
            margin: 0 !important;
            border: 0 !important;
            border-radius: 50% !important;
            background: #e8fbfc !important;
            color: #22bbc0 !important;
            font-size: 12px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-step-copy {
            min-width: 0 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-step-copy h3 {
            margin: -1px 0 0 !important;
            color: var(--studio-text) !important;
            font-size: 16px !important;
            font-weight: 800 !important;
            line-height: 1.35 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-step-copy p {
            margin: 4px 0 0 !important;
            color: #687585 !important;
            font-size: 13px !important;
            font-weight: 400 !important;
            line-height: 1.45 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-preset-field {
            width: 100% !important;
            height: 54px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 13px !important;
            margin: 0 !important;
            padding: 0 15px !important;
            border: 1px solid #cdd9e2 !important;
            border-radius: 5px !important;
            background: #fff !important;
            color: #222b36 !important;
            text-align: left !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-preset-field.fixed:hover {
            border: 1px solid #cdd9e2 !important;
            border-radius: 5px !important;
            background: #fff !important;
            transform: translateY(0px) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-summary-box {
            flex: 0 0 auto !important;
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
            margin: 0 !important;
            padding: 12px 16px !important;
            // border: 0 !important;
            border-top: 1px solid var(--studio-line) !important;
            background: #f8fafc !important;
            text-align: center !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-summary-title {
            color: #6b7280 !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            line-height: 1.35 !important;
            text-align: center !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-summary-body {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
            text-align: center !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-main-text {
            color: var(--studio-navy) !important;
            font-size: 17px !important;
            font-weight: 800 !important;
            line-height: 1.35 !important;
            white-space: nowrap !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-separator {
            color: #9ca3af !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-sub-text {
            color: #0284c7 !important;
            font-size: 11px !important;
            font-weight: 600 !important;
            line-height: 1.35 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-usage-loading-text {
            color: #6b7280 !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            line-height: 1.5 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-preset-field:hover,
          #RoboMDAICopywriterModal .robomd-copywriter-preset-field:focus {
            border-color: var(--studio-mint) !important;
            outline: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-preset-name {
            min-width: 0 !important;
            overflow: hidden !important;
            font-size: 15px !important;
            font-weight: 500 !important;
            line-height: 1 !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-preset-change {
            flex: 0 0 auto !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
            color: #17aeb2 !important;
            font-size: 12px !important;
            font-weight: 800 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-preset-change i {
            font-size: 11px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-auto-history-info {
            display: grid !important;
            gap: 10px !important;
            padding: 16px !important;
            border: 1px solid #b8ecee !important;
            border-radius: 8px !important;
            background: #f0fdfe !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-auto-history-info-row {
            display: grid !important;
            grid-template-columns: 90px minmax(0, 1fr) !important;
            gap: 10px !important;
            align-items: start !important;
            font-size: 13px !important;
            line-height: 1.45 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-auto-history-info-label {
            color: #64748b !important;
            font-weight: 700 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-auto-history-info-value {
            min-width: 0 !important;
            color: var(--studio-navy) !important;
            font-weight: 700 !important;
            word-break: break-word !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-card.readonly {
            cursor: default !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-card.readonly input {
            cursor: default !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-command-card {
            min-height: 0 !important;
            flex: 1 1 auto !important;
            display: flex !important;
            flex-direction: column !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-command {
            width: 100% !important;
            min-height: 235px !important;
            flex: 1 1 auto !important;
            margin: 0 !important;
            padding: 14px 15px !important;
            resize: none !important;
            border: 1px solid #ccd7e0 !important;
            border-radius: 4px !important;
            background: #fff !important;
            color: #354151 !important;
            font-size: 15px !important;
            line-height: 1.65 !important;
            outline: none !important;
            box-shadow: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-command::placeholder {
            color: #949494;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-command:focus {
            border-color: var(--studio-mint) !important;
            box-shadow: 0 0 0 2px rgba(66, 211, 214, .1) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-generate-row {
            flex: 0 0 auto !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 18px !important;
            margin: 14px 0 0 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-generate-help {
            min-width: 0 !important;
            margin: 0 !important;
            color: #768291 !important;
            font-size: 11px !important;
            line-height: 1.45 !important;
          }


          #RoboMDAICopywriterModal .robomd-copywriter-setting-link {
            min-width: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            margin: 0 !important;
            padding: 9px 13px !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 8px !important;
            background: #f8fafc !important;
            color: #6b7280 !important;
            font-size: 13px !important;
            font-weight: 600 !important;
            line-height: 1.2 !important;
            white-space: nowrap !important;
            cursor: pointer !important;
            user-select: none !important;
            transition: border-color .2s ease, color .2s ease, background .2s ease !important;
            height: 42px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-setting-link:hover,
          #RoboMDAICopywriterModal .robomd-copywriter-setting-link:focus-visible {
            border-color: var(--studio-navy) !important;
            background: #fff !important;
            color: var(--studio-navy) !important;
            outline: none !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-setting-link svg {
            width: 18px !important;
            height: 18px !important;
            flex: 0 0 auto !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-generate-button {
            min-width: 145px !important;
            height: 42px !important;
            flex: 0 0 auto !important;
            margin: 0 !important;
            padding: 10px 16px !important;
            border: 1px solid var(--studio-navy) !important;
            border-radius: 8px !important;
            background: var(--studio-navy) !important;
            color: #fff !important;
            font-size: 15px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
            cursor: pointer !important;
            align-items: center;
            height: 42px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-generate-button i {
            margin-right: 4px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-generate-button:disabled {
            opacity: .55 !important;
            cursor: not-allowed !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-panel {
            min-width: 0 !important;
            min-height: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
            background: #f3f8fb !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-header {
            flex: 0 0 auto !important;
            display: flex !important;
            align-items: flex-start !important;
            justify-content: space-between !important;
            gap: 12px !important;
            margin: 0 !important;
            padding: 20px 20px 14px !important;
            border: 0 !important;
            background: transparent !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-header-main {
            min-width: 0 !important;
            display: flex !important;
            align-items: flex-start !important;
            gap: 11px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-header-copy h3 {
            margin: -1px 0 0 !important;
            color: var(--studio-text) !important;
            font-size: 16px !important;
            font-weight: 800 !important;
            line-height: 1.3 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-header-copy p {
            margin: 4px 0 0 !important;
            color: #758291 !important;
            font-size: 13px !important;
            line-height: 1.4 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-clear-selection {
            flex: 0 0 auto !important;
            min-width: 66px !important;
            height: 38px !important;
            margin: 0 !important;
            padding: 10px !important;
            border: 0 !important;
            border-radius: 14px !important;
            background: #e8edf3 !important;
            color: #59677a !important;
            font-size: 11px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
            cursor: pointer !important;
            align-items: center;
            height: auto !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-clear-selection:disabled {
            opacity: .55 !important;
            cursor: default !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-content {
            min-height: 0 !important;
            flex: 1 1 auto !important;
            margin: 0 !important;
            padding: 0 18px 18px !important;
            overflow-x: hidden !important;
            overflow-y: auto !important;
            overscroll-behavior: contain !important;
            -webkit-overflow-scrolling: touch !important;
            background: transparent !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-empty-state {
            min-height: 500px !important;
            height: 100% !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            padding: 36px !important;
            border: 1px dashed #adc0cf !important;
            border-radius: 8px !important;
            background: rgba(255, 255, 255, 0.72) !important;
            color: #7f8b99 !important;
            text-align: center !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-empty-icon {
            width: 54px !important;
            height: 54px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 0 20px !important;
            border-radius: 9px !important;
            background: #e9fafb !important;
            color: #19aeb3 !important;
            font-size: 24px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-empty-state strong {
            margin: 0 0 6px !important;
            color: #3f4a57 !important;
            font-size: 15px !important;
            font-weight: 800 !important;
            line-height: 1.3 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-empty-state p {
            margin: 0 !important;
            color: #8994a1 !important;
            font-size: 13px !important;
            line-height: 1.5 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-list {
            display: flex !important;
            flex-direction: column !important;
            gap: 12px !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-card {
            margin: 0 !important;
            padding: 18px !important;
            border: 1px solid #d9e2e9 !important;
            border-radius: 7px !important;
            background: #fff !important;
            box-shadow: none !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-card:hover {
            border-color: #8bdee1 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-card.selected {
            padding: 17px !important;
            border: 2px solid var(--studio-mint) !important;
            // background: #f1fcfd !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-card-header {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 13px !important;
            margin: 0 0 10px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-check-wrap {
            min-width: 0 !important;
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            color: #374151 !important;
            font-size: 13px !important;
            font-weight: 800 !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-check-wrap input {
            display: block !important;
            width: 16px !important;
            height: 16px !important;
            margin: 0 !important;
            accent-color: var(--studio-mint-deep) !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-applied-badge {
            display: inline-flex !important;
            align-items: center !important;
            min-height: 20px !important;
            padding: 3px 7px !important;
            border-radius: 10px !important;
            background: #e6fbfc !important;
            color: #087f83 !important;
            font-size: 10px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-number {
            color: #9aa4ae !important;
            font-size: 10px !important;
            font-weight: 700 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-result-text {
            width: 100% !important;
            height: auto !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            background: #fff !important;
            color: #4a5664 !important;
            font-size: 15px !important;
            line-height: 1.6 !important;
            white-space: pre-wrap !important;
            overflow-wrap: anywhere !important;
            word-break: break-word !important;
            user-select: text !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-wrapper {
            min-width: 0 !important;
            flex: 0 0 auto !important;
            display: flex !important;
            flex-direction: row !important;
          }
          #RoboMDAICopywriterModal .robomd-copywriter-footer {
            flex: 1 !important;
            // width: 100% !important;
            height: auto !important;
            min-height: 84.97px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 16px !important;
            margin: 0 !important;
            padding: 10px 18px !important;
            box-sizing: border-box !important;
            border: 0 !important;
            border-top: 1px solid var(--studio-line) !important;
            background: #fff !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-status {
            min-width: 0 !important;
            margin: 0 !important;
            color: #8a95a1 !important;
            font-size: 10px !important;
            line-height: 1.45 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-status strong {
            display: block !important;
            margin: 0 0 2px !important;
            color: #414c59 !important;
            font-size: 15px !important;
            font-weight: 800 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-status strong.error {
            color: #d64545 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-actions {
            flex: 0 0 auto !important;
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-button {
            height: 42px !important;
            border-radius: var(--radius-sm);
            margin: 0 !important;
            padding: 10px 16px !important;
            font-size: 14px;
            font-weight: 700;
            cursor: pointer;
            border: none;
            transition: 0.2s;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            white-space: nowrap;
          }

          #RoboMDAICopywriterModal button:hover {
            transform: translateY(-1px);
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-button.cancel {
            box-shadow: 0 0 0 0px transparent !important;
            border: 1px solid #d1d5db;
            color: #4b5563;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-button.cancel:hover {
            border-color: var(--cw-mint) !important;
            background: #f0fdfe !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-button.copy {
            background: white;
            color: #00A396;
            border: 1px solid #00C4B5;
          }
          
          #RoboMDAICopywriterModal .robomd-copywriter-footer-button.copy:hover {
            border: 1px solid #00A396 !important;
            background: #E0F7F6 !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-button.apply {
            border: 1px solid var(--studio-mint) !important;
            background: var(--studio-mint) !important;
            color: #0A1A2F !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-footer-button:disabled {
            border-color: #d9e4e8 !important;
            background: #d9e4e8 !important;
            color: #fff !important;
            cursor: not-allowed !important;
          }


          #RoboMDAICopywriterModal .robomd-copywriter-mobile-history-button {
            display: none !important;
            width: 38px !important;
            height: 38px !important;
            flex: 0 0 38px !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 1px solid rgba(255, 255, 255, .18) !important;
            border-radius: 7px !important;
            background: rgba(255, 255, 255, .08) !important;
            color: #fff !important;
            font-size: 16px !important;
            cursor: pointer !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-mobile-header-actions {
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
          }

          #RoboMDAICopywriterModal .robomd-copywriter-mobile-history-backdrop {
            display: none !important;
          }

          .robomd-copywriter-toast {
            position: fixed !important;
            left: 50% !important;
            bottom: 28px !important;
            z-index: 13150 !important;
            transform: translateX(-50%);
            max-width: calc(100vw - 32px) !important;
            padding: 12px 16px !important;
            border-radius: 10px !important;
            background: #0c1629 !important;
            color: #fff !important;
            box-shadow: 0 12px 30px rgba(0, 0, 0, .24) !important;
            font-size: 13px !important;
            font-weight: 700 !important;
            line-height: 1.45 !important;
            text-align: center !important;
            pointer-events: none !important;
            animation: robomdCopywriterToastIn .18s ease-out !important;
          }

          .robomd-copywriter-toast[hidden] {
            display: none !important;
          }

          @keyframes robomdCopywriterToastIn {
            from {
              opacity: 0;
              transform: translate(-50%, 8px);
            }
            to {
              opacity: 1;
              transform: translate(-50%, 0);
            }
          }

          @media (max-width: 980px) {
            #RoboMDAICopywriterModal.robomd-copywriter-overlay {
              align-items: stretch !important;
              justify-content: stretch !important;
              padding: 0 !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-modal {
              position: relative !important;
              left: auto !important;
              top: auto !important;
              width: 100% !important;
              height: 100dvh !important;
              max-height: 100dvh !important;
              border-radius: 0 !important;
              transform: none !important;
            }

            @supports not (height: 100dvh) {
              #RoboMDAICopywriterModal .robomd-copywriter-modal {
                height: 100vh !important;
                max-height: 100vh !important;
              }
            }

            #RoboMDAICopywriterModal .robomd-copywriter-header {
              position: relative !important;
              z-index: 60 !important;
              flex: 0 0 58px !important;
              height: 58px !important;
              min-height: 58px !important;
              padding: 0 12px 0 14px !important;
              cursor: default !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-brand {
              gap: 9px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-brand-mark {
              width: 22px !important;
              height: 22px !important;
              flex-basis: 22px !important;
              // font-size: 13px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-title {
              max-width: calc(100vw - 142px) !important;
              font-size: 18px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-mobile-history-button {
              display: inline-flex !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-close {
              width: 36px !important;
              height: 36px !important;
              flex-basis: 36px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-body,
            #RoboMDAICopywriterModal .robomd-copywriter-body.no-history {
              position: relative !important;
              min-width: 0 !important;
              min-height: 0 !important;
              flex: 1 1 auto !important;
              display: block !important;
              margin: 0 !important;
              overflow: hidden !important;
              background: var(--studio-bg) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-mobile-history-backdrop {
              position: absolute !important;
              inset: 58px 0 0 0 !important;
              z-index: 45 !important;
              display: block !important;
              margin: 0 !important;
              padding: 0 !important;
              border: 0 !important;
              background: rgba(15, 23, 42, .46) !important;
              cursor: default !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-history-sidebar {
              position: absolute !important;
              top: 0 !important;
              bottom: 0 !important;
              left: 0 !important;
              z-index: 50 !important;
              width: min(84vw, 330px) !important;
              height: 100% !important;
              max-height: none !important;
              border-right: 1px solid var(--studio-line) !important;
              border-bottom: 0 !important;
              box-shadow: 10px 0 28px rgba(15, 23, 42, .18) !important;
              transform: translateX(-105%) !important;
              transition: transform .24s ease !important;
              will-change: transform !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-history-sidebar.mobile-open {
              transform: translateX(0) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-history-header {
              padding: 13px 12px 10px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-history-list {
              max-height: none !important;
              padding: 7px !important;
              overflow-x: hidden !important;
              overflow-y: auto !important;
              overscroll-behavior: contain !important;
              -webkit-overflow-scrolling: touch !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-history-menu {
              top: 27px !important;
              right: 0 !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-usage-summary-box {
              padding: 10px 12px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-inner {
              width: 100% !important;
              height: 100% !important;
              min-width: 0 !important;
              min-height: 0 !important;
              overflow: hidden !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-inner-body {
              min-width: 0 !important;
              min-height: 0 !important;
              flex: 1 1 auto !important;
              display: flex !important;
              flex-direction: column !important;
              grid-template-columns: none !important;
              overflow-x: hidden !important;
              overflow-y: auto !important;
              overscroll-behavior: contain !important;
              -webkit-overflow-scrolling: touch !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-builder {
              min-height: auto !important;
              flex: 0 0 auto !important;
              gap: 13px !important;
              padding: 14px !important;
              overflow: visible !important;
              border-right: 0 !important;
              border-bottom: 1px solid var(--studio-line) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-form-card {
              padding: 16px !important;
              border-radius: 10px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-command-card {
              min-height: auto !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-command {
              min-height: 170px !important;
              flex: 0 0 170px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-panel {
              min-height: 380px !important;
              flex: 0 0 auto !important;
              overflow: visible !important;
              border-top: 0 !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-header {
              padding: 17px 15px 12px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-content {
              min-height: 300px !important;
              padding: 0 14px 16px !important;
              overflow: visible !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-empty-state {
              min-height: 280px !important;
              height: auto !important;
              padding: 28px 18px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-wrapper {
              position: relative !important;
              z-index: 30 !important;
              flex: 0 0 auto !important;
              width: 100% !important;
              min-width: 0 !important;
              display: block !important;
              border-top: 1px solid var(--studio-line) !important;
              background: #fff !important;
              box-shadow: 0 -4px 16px rgba(15, 23, 42, .06) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-body:not(.no-history) .robomd-copywriter-footer-wrapper > .robomd-copywriter-usage-summary-box {
              display: none !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-body.no-history .robomd-copywriter-footer-wrapper > .robomd-copywriter-usage-summary-box {
              width: 100% !important;
              border-right: 0 !important;
              border-bottom: 1px solid var(--studio-line) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer {
              width: 100% !important;
              min-width: 0 !important;
              min-height: 0 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: space-between !important;
              gap: 10px !important;
              padding:
                9px 11px
                max(9px, env(safe-area-inset-bottom)) !important;
              border-top: 0 !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-status {
              flex: 1 1 auto !important;
              min-width: 0 !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-status strong {
              margin-bottom: 0 !important;
              font-size: 13px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-status span {
              display: none !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-actions {
              flex: 0 0 auto !important;
              min-width: 0 !important;
              display: flex !important;
              gap: 7px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-button {
              min-width: 112px !important;
              height: 42px !important;
              padding: 8px 11px !important;
              font-size: 12px !important;
              line-height: 1 !important;
            }

            #RoboMDAICopywriterModal button:hover {
              transform: none !important;
            }
          }

          @media (max-width: 620px) {
            #RoboMDAICopywriterModal .robomd-copywriter-title {
              max-width: calc(100vw - 132px) !important;
              font-size: 17px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-builder {
              padding: 11px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-form-card {
              padding: 14px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-step-title {
              gap: 9px !important;
              margin-bottom: 11px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-step-copy h3,
            #RoboMDAICopywriterModal .robomd-copywriter-result-header-copy h3 {
              font-size: 15px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-step-copy p,
            #RoboMDAICopywriterModal .robomd-copywriter-result-header-copy p {
              font-size: 12px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-preset-field {
              height: 50px !important;
              padding: 0 12px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-command {
              min-height: 150px !important;
              flex-basis: 150px !important;
              padding: 12px !important;
              font-size: 14px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-generate-row {
              align-items: stretch !important;
              flex-direction: column !important;
              gap: 8px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-setting-link,
            #RoboMDAICopywriterModal .robomd-copywriter-generate-button {
              width: 100% !important;
              min-width: 0 !important;
              justify-content: center !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-setting-link {
              white-space: normal !important;
              text-align: center !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-panel {
              min-height: 340px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-content {
              min-height: 260px !important;
              padding: 0 11px 13px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-empty-state {
              min-height: 240px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-card {
              padding: 15px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-card.selected {
              padding: 14px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-result-text {
              font-size: 14px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer {
              display: block !important;
              padding:
                8px 10px
                max(8px, env(safe-area-inset-bottom)) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-status {
              margin-bottom: 7px !important;
              text-align: center !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-actions {
              width: 100% !important;
              display: grid !important;
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-button {
              width: 100% !important;
              min-width: 0 !important;
              height: 42px !important;
              padding: 7px 6px !important;
              font-size: 12px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-actions > :only-child {
              grid-column: 1 / -1 !important;
            }
          }

          @media (max-width: 380px) {
            #RoboMDAICopywriterModal .robomd-copywriter-title {
              max-width: calc(100vw - 124px) !important;
              font-size: 16px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-mobile-history-button,
            #RoboMDAICopywriterModal .robomd-copywriter-close {
              width: 34px !important;
              height: 34px !important;
              flex-basis: 34px !important;
            }

            #RoboMDAICopywriterModal .robomd-copywriter-footer-button {
              font-size: 11px !important;
            }
          }
        `}</style>

        <div
          id="RoboMDAICopywriterModal"
          className="robomd-copywriter-overlay"
          data-instagram-tutorial-popup="POPUP_COPYWRITER_RUN"
        >
          <section
            ref={this.modalRef}
            className="robomd-copywriter-modal"
            role="dialog"
            aria-modal="false"
            aria-labelledby="robomdCopywriterTitle"
            style={{
              transform: `translate(calc(-50% + ${dragX}px), calc(-50% + ${dragY}px))`,
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <header
              className="robomd-copywriter-header"
              onMouseDown={this.startModalDrag}
              title="헤더를 드래그하여 팝업을 이동할 수 있습니다."
            >
              <div className="robomd-copywriter-brand">
                <span className="robomd-copywriter-brand-mark" aria-hidden="true">
                  <img src={"https://robomd.io/images/home/logo_favicon.svg"} alt="로보MD AI 카피라이터" style={{ width: "100%", height: "auto"}} />
                </span>
                <h2 id="robomdCopywriterTitle" className="robomd-copywriter-title">
                  {this.props.modalTitle || '로보MD AI 카피라이터'}
                </h2>
              </div>

              <div className="robomd-copywriter-mobile-header-actions">
                {historyEnabled ? (
                  <button
                    type="button"
                    className="robomd-copywriter-mobile-history-button"
                    aria-label={isMobileHistoryOpen ? '히스토리 닫기' : '히스토리 열기'}
                    aria-expanded={isMobileHistoryOpen}
                    onClick={this.toggleMobileHistory}
                  >
                    <i className="fa fa-history" aria-hidden="true" />
                  </button>
                ) : null}

                <button
                  type="button"
                  className="robomd-copywriter-close"
                  aria-label="팝업 닫기"
                  onClick={this.handleClose}
                >
                  ×
                </button>
              </div>
            </header>

            {historyEnabled && isMobileHistoryOpen ? (
              <button
                type="button"
                className="robomd-copywriter-mobile-history-backdrop"
                aria-label="히스토리 닫기"
                onClick={this.closeMobileHistory}
              />
            ) : null}

            <div className={`robomd-copywriter-body ${historyEnabled ? '' : 'no-history'}`}>

              {historyEnabled ? (
              <aside className={`robomd-copywriter-history-sidebar ${isMobileHistoryOpen ? 'mobile-open' : ''}`}>
                <div className="robomd-copywriter-history-header">
                  <button
                    type="button"
                    className="robomd-copywriter-new-history-button"
                    onClick={() => {
                      this.startNewHistory();
                    }}
                    disabled={!!isGenerating || !!isHistoryDetailLoading}
                  >
                    <span>새 문구 작성</span>
                    <span aria-hidden="true">
                      <img src="https://robomd.io/static/media/default_plus.466aee97.svg" alt="+" style={{ width: '20px', height: '20px' }} />
                    </span>
                  </button>
                </div>

                <div className="robomd-copywriter-history-filter-wrap" role="tablist" aria-label="카피라이터 히스토리 구분">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={historySourceType === 'MANUAL'}
                    className={`robomd-copywriter-history-filter-button ${historySourceType === 'MANUAL' ? 'active' : ''}`}
                    disabled={!!isGenerating || !!isHistoryDetailLoading}
                    onClick={() => this.handleHistorySourceChange('MANUAL')}
                  >
                    내 히스토리
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={historySourceType === 'AUTO'}
                    className={`robomd-copywriter-history-filter-button ${historySourceType === 'AUTO' ? 'active' : ''}`}
                    disabled={!!isGenerating || !!isHistoryDetailLoading}
                    onClick={() => this.handleHistorySourceChange('AUTO')}
                  >
                    자동 히스토리
                  </button>
                </div>

                <div className="robomd-copywriter-history-list">
                  {isHistoryLoading ? (
                    <div className="robomd-copywriter-history-empty">히스토리를 불러오는 중입니다.</div>
                  ) : historyItems.length === 0 ? (
                    <div className="robomd-copywriter-history-empty">{isAutoHistoryList ? '아직 저장된 자동 히스토리가 없습니다.' : '아직 저장된 문구 히스토리가 없습니다.'}</div>
                  ) : (
                    Object.keys(groupedHistory).map((groupLabel) => (
                      <React.Fragment key={groupLabel}>
                        <div className="robomd-copywriter-history-group-title">{groupLabel}</div>
                        {groupedHistory[groupLabel].map((historyItem) => {
                          const historySeq = historyItem.copywriter_history_seq;
                          const isActive = String(selectedHistorySeq || '') === String(historySeq || '');

                          return (
                            <div
                              key={historySeq}
                              role="button"
                              tabIndex={0}
                              className={`robomd-copywriter-history-item ${isActive ? 'active' : ''} ${isGenerating || isHistoryDetailLoading ? 'disabled' : ''}`}
                              onClick={() => {
                                if (!isGenerating && !isHistoryDetailLoading) {
                                  this.loadHistoryDetail(historySeq);
                                }
                              }}
                              onKeyDown={(event) => {
                                if ((event.key === 'Enter' || event.key === ' ') && !isGenerating && !isHistoryDetailLoading) {
                                  event.preventDefault();
                                  this.loadHistoryDetail(historySeq);
                                }
                              }}
                              title={historyItem.history_title || '문구 히스토리'}
                            >
                              <span className="robomd-copywriter-history-item-text">
                                {historyItem.history_title || '새 문구 생성'}
                              </span>
                              <span className="robomd-copywriter-history-menu-wrap">
                                <button
                                  type="button"
                                  className="robomd-copywriter-history-menu-trigger"
                                  aria-label="히스토리 메뉴"
                                  onClick={(event) => this.toggleHistoryMenu(event, historyItem)}
                                >
                                  ⋯
                                </button>
                                {String(historyMenuSeq || '') === String(historySeq || '') ? (
                                  <span
                                    className="robomd-copywriter-history-menu"
                                    onClick={(event) => event.stopPropagation()}
                                  >
                                    {String(historyItem.source_type || 'MANUAL').toUpperCase() !== 'AUTO' ? (
                                      <button
                                        type="button"
                                        onClick={(event) => this.handleHistoryRename(event, historyItem)}
                                      >
                                        이름 변경
                                      </button>
                                    ) : null}
                                    <button
                                      type="button"
                                      disabled={!!historyDuplicateSeq}
                                      onClick={(event) => this.handleHistoryDuplicate(event, historyItem)}
                                    >
                                      새 작업으로 복제
                                    </button>
                                    <button
                                      type="button"
                                      className="delete"
                                      onClick={(event) => this.handleHistoryDelete(event, historyItem)}
                                    >
                                      삭제
                                    </button>
                                  </span>
                                ) : null}
                              </span>
                            </div>
                          );
                        })}
                      </React.Fragment>
                    ))
                  )}
                </div>

                {gptUsage?.is_api_limit_apply_yn === 'Y' ? (
                  <div className="robomd-copywriter-usage-summary-box">
                    <div className="robomd-copywriter-usage-summary-title">
                      AI 카피라이터 호출량
                    </div>
                    <div className="robomd-copywriter-usage-summary-body">
                      {gptUsageLoading ? (
                        <span className="robomd-copywriter-usage-loading-text">불러오는 중...</span>
                      ) : (
                        <>
                          <span className="robomd-copywriter-usage-main-text">
                            {Number(gptUsage.total_used_gpt_char_count || 0).toLocaleString()}자
                            <span className="robomd-copywriter-usage-separator"> / </span>
                            {Number(gptUsage.total_available_gpt_char_count || 0).toLocaleString()}자
                          </span>
                          <span className="robomd-copywriter-usage-sub-text">
                            사용된 호출량 / 총 호출량 
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                ) : null}
              </aside>
              ) : null}

              <div className="robomd-copywriter-inner">
                <div className="robomd-copywriter-inner-body">
                  <div className="robomd-copywriter-builder">
                    <section className="robomd-copywriter-form-card">
                      <div className="robomd-copywriter-step-title">
                        <span className="robomd-copywriter-step-badge">1</span>
                        <div className="robomd-copywriter-step-copy">
                          {
                            isAutoHistory
                            ? <h3>사용된 AI 카피라이터</h3>
                            : <h3>사용할 AI 카피라이터</h3>
                          }
                          {
                            fixedPresetMode
                            ? <p>방금 저장한 카피라이터 설정의 브랜드 톤과 작성규칙을 사용합니다.</p>
                            : isAutoHistory
                              ? <p>자동화 실행 당시 사용한 AI 카피라이터입니다.</p>
                              : <p>저장해 둔 카피라이터로 브랜드 톤과 작성규칙을 선택하세요.</p>
                          }
                        </div>
                      </div>

                      <button
                        type="button"
                        className={`robomd-copywriter-preset-field ${fixedPresetMode || isAutoHistory ? 'fixed' : ''}`}
                        onClick={this.openSelectModal}
                        disabled={fixedPresetMode || isAutoHistory || isPresetLoading}
                        title={isAutoHistory ? '자동화 실행 당시 사용한 AI 카피라이터입니다.' : (fixedPresetMode ? '저장 후 즉시 실행에서는 현재 설정으로 고정됩니다.' : 'AI 카피라이터 변경')}
                      >
                        <span className="robomd-copywriter-preset-name">
                          {isPresetLoading ? 'AI 카피라이터를 불러오는 중...' : selectedTitle}
                        </span>
                        {fixedPresetMode || isAutoHistory ? (
                          <span className="robomd-copywriter-preset-change">{isAutoHistory ? '자동화 사용' : ''}</span>
                        ) : (
                          <span className="robomd-copywriter-preset-change">
                            변경 <i className="fa fa-caret-right" aria-hidden="true" />
                          </span>
                        )}
                      </button>

                    </section>

                    {isAutoHistory ? (
                      <section className="robomd-copywriter-form-card robomd-copywriter-command-card">
                        <div className="robomd-copywriter-step-title">
                          <span className="robomd-copywriter-step-badge">2</span>
                          <div className="robomd-copywriter-step-copy">
                            <h3>자동화 생성 정보</h3>
                            <p>자동화 실행 정보와 실제 생성 결과를 확인할 수 있습니다</p>
                          </div>
                        </div>

                        {hasSelectedAutoHistory ? (
                          <div className="robomd-copywriter-auto-history-info">
                            <div className="robomd-copywriter-auto-history-info-row">
                              <span className="robomd-copywriter-auto-history-info-label">자동화 유형</span>
                              <span className="robomd-copywriter-auto-history-info-value">{automationTypeLabel}</span>
                            </div>
                            <div className="robomd-copywriter-auto-history-info-row">
                              <span className="robomd-copywriter-auto-history-info-label">자동화 설정</span>
                              <span className="robomd-copywriter-auto-history-info-value">{automationSettingTitle}</span>
                            </div>
                          </div>
                        ) : (
                          <div className="robomd-copywriter-auto-history-info">
                            <div className="robomd-copywriter-history-empty">왼쪽 자동 히스토리에서 확인할 기록을 선택해주세요.</div>
                          </div>
                        )}
                      </section>
                    ) : (
                    <section className="robomd-copywriter-form-card robomd-copywriter-command-card">
                      <div className="robomd-copywriter-step-title">
                        <span className="robomd-copywriter-step-badge">2</span>
                        <div className="robomd-copywriter-step-copy">
                          <h3>이번 문구에 필요한 내용</h3>
                          <p>AI에게 작성할 문구에 필요한 명령을 시킬 수 있습니다</p>
                        </div>
                      </div>

                      <textarea
                        id="robomdCopywriterCommand"
                        className="robomd-copywriter-command"
                        value={command || ''}
                        onChange={(e) => this.setState({ command: e.target.value })}
                        placeholder={this.props.commandPlaceholder || '가격, 특징, 꼭 포함할 표현, 피해야 할 표현 등을 입력하세요.'}
                      />

                      <div className="robomd-copywriter-generate-row">
                        <span
                          className="setting-link robomd-copywriter-setting-link"
                          title="AI 자동 환경설정 메뉴에서 변경할 수 있습니다."
                          role="button"
                          tabIndex={0}
                          onClick={this.handleOpenCaptionSettings}
                          onKeyDown={this.handleCaptionSettingsKeyDown}
                        >
                          <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6b7280"></path></svg>
                          문구 {createCount}개{autoHashtagEnabled ? `, 자동 해시태그 ${hashtagCount > 0 ? `${hashtagCount}개` : ''}` : ''} 생성
                        </span>
                        <button
                          type="button"
                          className="robomd-copywriter-generate-button"
                          disabled={!!isGenerating}
                          onClick={() => {
                            this.generateCopywriterRecommendations();
                          }}
                        >
                          {/* <i className="fa fa-magic" aria-hidden="true" /> */}
                          <i>✦</i>
                          {isGenerating ? ' 생성 중...' : ` 문구 ${createCount}개 만들기`}
                        </button>
                      </div>
                    </section>
                    )}
                  </div>

                  <aside className="robomd-copywriter-result-panel">
                    <div className="robomd-copywriter-result-header">
                      <div className="robomd-copywriter-result-header-main">
                        <span className="robomd-copywriter-step-badge">3</span>
                        <div className="robomd-copywriter-result-header-copy">
                          <h3>{isAutoHistory ? '자동화가 만든 문구' : 'AI가 만든 문구'}</h3>
                          <p>
                            {/* {isAutoHistory ? '수동 작업에 가져올 문구를 선택하세요. 배지는 자동화에서 실제 사용된 문구를 의미합니다.' : '마음에 드는 문구를 선택하세요.'} */}
                            마음에 드는 문구를 선택하세요.
                          </p>
                        </div>
                      </div>

                      <div className="robomd-copywriter-result-header-actions">
                        {/* {isAutoHistory ? (
                          <span className="robomd-copywriter-history-auto-badge">자동 실행</span>
                        ) : null} */}
                        <button
                          type="button"
                          className="robomd-copywriter-clear-selection"
                          disabled={selectedCount === 0}
                          onClick={this.handleClearSelection}
                        >
                          {/* 선택 해제 */}
                          {selectedCount}개 선택
                        </button>
                      </div>
                    </div>

                    <div className="robomd-copywriter-result-content">
                      {!hasResults ? (
                        <div className="robomd-copywriter-empty-state">
                          <div className="robomd-copywriter-empty-icon" aria-hidden="true">
                            {/* <i className="fa fa-star" /> */}
                            ✦
                          </div>
                          <strong>{isAutoHistory ? '선택된 자동 히스토리가 없습니다.' : '아직 만든 문구가 없습니다.'}</strong>
                          <p>{isAutoHistory ? '왼쪽 자동 히스토리에서 확인할 기록을 선택해주세요.' : `왼쪽 내용을 확인한 뒤 ‘문구 ${createCount}개 만들기’를 눌러주세요.`}</p>
                        </div>
                      ) : (
                        <div className="robomd-copywriter-result-list">
                          {recommendations.map(this.renderResultItem)}
                        </div>
                      )}
                    </div>
                  </aside>
                </div>

                <div className="robomd-copywriter-footer-wrapper">
                  {(!historyEnabled  && gptUsage?.is_api_limit_apply_yn === 'Y') ? (
                    <div className="robomd-copywriter-usage-summary-box" style={{borderRight: "1px solid var(--studio-line)"}}>
                      <div className="robomd-copywriter-usage-summary-title">
                        AI 카피라이터 호출량
                      </div>
                      <div className="robomd-copywriter-usage-summary-body">
                        {gptUsageLoading ? (
                          <span className="robomd-copywriter-usage-loading-text">불러오는 중...</span>
                        ) : (
                          <>
                            <span className="robomd-copywriter-usage-main-text">
                              {Number(gptUsage.total_used_gpt_char_count || 0).toLocaleString()}자
                              <span className="robomd-copywriter-usage-separator"> / </span>
                              {Number(gptUsage.total_available_gpt_char_count || 0).toLocaleString()}자
                            </span>
                            <span className="robomd-copywriter-usage-sub-text">
                              사용된 호출량 / 총 호출량 
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div className="robomd-copywriter-footer">
                    <div className="robomd-copywriter-footer-status">
                      {selectedCount > 0 ? (
                        <strong>문구 {selectedCount}개가 선택되었습니다.</strong>
                      ) : (
                        <strong>{isAutoHistory ? '가져올 자동화 문구를 선택해주세요.' : '적용할 문구를 선택해주세요.'}</strong>
                      )}
                      <span>
                        {isAutoHistory
                          ? `자동 히스토리 선택은 현재 ${this.getApplyTargetLabel()}에만 적용되며 자동화 기록은 변경되지 않습니다.`
                          : `여러 개를 선택하면 ${this.getApplyTargetLabel()}에 순서대로 합쳐 적용됩니다.`}
                      </span>
                    </div>

                    <div className="robomd-copywriter-footer-actions">
                      <button
                        type="button"
                        className="robomd-copywriter-footer-button copy"
                        disabled={selectedCount === 0}
                        onClick={this.handleCopy}
                      >
                        선택 문구 복사
                      </button>
                      {this.props.onContentRegister ? (
                        <button
                          type="button"
                          className="robomd-copywriter-footer-button apply"
                          disabled={selectedCount === 0}
                          onClick={this.handleContentRegister}
                        >
                          {this.props.contentRegisterButtonLabel ||
                            '선택 문구로 콘텐츠 등록하러 가기'}
                        </button>
                      ) : null}
                      {this.props.onApply ? (
                        <button
                          type="button"
                          className="robomd-copywriter-footer-button apply"
                          disabled={selectedCount === 0}
                          onClick={this.handleApply}
                        >
                          {this.props.applyButtonLabel || '선택 문구 적용'}
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>


        <div
          className="robomd-copywriter-toast"
          role="status"
          aria-live="polite"
          hidden={!toastMessage}
        >
          {toastMessage}
        </div>

        {!fixedPresetMode ? (
        <AICopywriterModal
          selectedId={selectedPresetId || ''}
          isOpen={isSelectModalOpen}
          onClose={this.closeSelectModal}
          onApply={this.handlePresetApply}
          getCopywriterList={this.handlePresetListLoaded}
        />
        ) : null}

        {isHistoryRenameDialogOpen && historyRenameTarget ? (
          <InputDialogV3
            title="카피라이터 히스토리 이름 변경"
            content="변경할 히스토리 이름을 입력해주세요."
            input_list={[
              {
                title: '히스토리 이름',
                value: historyRenameTarget.history_title || '새 문구 생성',
                placeholder: '히스토리 이름을 입력해주세요.',
              },
            ]}
            button_text="변경"
            is_show_close={true}
            onPopupClose={this.closeHistoryRenameDialog}
            onButtonClick={this.confirmHistoryRename}
          />
        ) : null}

        {isHistoryDeleteDialogOpen ? (
          <TitleContentDialogV2
            title="카피라이터 히스토리를 삭제하시겠습니까?"
            content="삭제한 카피라이터 히스토리는 복구할 수 없습니다."
            button_list={[
              {
                title: '삭제',
                type: '1',
                event_method: this.confirmHistoryDelete,
              },
              {
                title: '취소',
                type: '0',
                event_method: this.closeHistoryDeleteDialog,
              },
            ]}
            popup_close={this.closeHistoryDeleteDialog}
          />
        ) : null}
      </>
    );
  }
}

RoboMDAICopywriterModal.defaultProps = {
  presetMode: 'DEFAULT',
  fixedPresetSeq: null,
  initialPresetSeq: null,
  generationContext: {},
  historyEnabled: true,
  initialCommand: '',
  generationInstruction: '',
  modalTitle: '로보MD AI 카피라이터',
  commandPlaceholder: '',
  applyTargetLabel: '문구 작성 에디터',
  applyButtonLabel: '선택 문구 적용',
  onContentRegister: null,
  contentRegisterButtonLabel: '선택 문구로 콘텐츠 등록하러 가기',
  closeOnApply: false,
};

export default RoboMDAICopywriterModal;
